import React, { Children, cloneElement } from 'react'

const Step = ({ children, className }) => {
    return (
        <div className={className}>
            {children}
        </div>
    );
};

export const Steps = ({ children, currentStep, className }) => {
    return (
        <div className={className}>
            {Children.map(children, (child, index) =>
                index === currentStep ? cloneElement(child) : null
            )}
        </div>
    );
};


Steps.Step = Step